<template><zen-one 
    :showuserinfo="false" 
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >

    <z-page title="Senarai : Terimaan">

        <div class="message-box">
          <w-transition-fade>
            <w-alert
              class="my0 text-light"
              v-if="form.submitted"
              success
              no-border>
              The form is valid, ready to send it!
            </w-alert>

            <w-alert
              class="my0 text-light"
              v-else-if="form.valid === false"
              error
              no-border>
              Terdapat {{ form.errorsCount }} ralat di dalam borang ini.
            </w-alert>
          </w-transition-fade>
        </div>

        <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess">

            <w-flex class="mt3">
                <div class="xs12">
                    <w-input
                    required
                    placeholder="Sila Masukan No. Rujukan"
                    label="No. Rujukan">
                    </w-input>
                </div>
                <div class="xs1">
                    <w-icon>fal fa-search</w-icon>
                    &nbsp;
                    <w-icon  @click="dialog.show = true">fal fa-plus</w-icon>
                </div>
                <div class="xs1" align="right">
                <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>

            <z-page title="Butiran Bayaran (Cukai)" class="mt3">

                    <div class="table-hardcode">
                    <w-card bg-color="" class="table-hardcode">
                        <table class="table-dashboard" width="100%">
                            <thead>
                                <tr>
                                    <td>Bil</td>
                                    <td>Jabatan</td>
                                    <td>No. Rujukan</td>
                                    <td>Nama</td>
                                    <td>Kod Akaun</td>
                                    <td>Butiran Bayaran</td>
                                    <td>Amaun (RM)</td>
                                    <td>Amaun Bayar (RM)</td>
                                    <td> </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>PEJABAT DAERAH YANG BERSANGKUTAN</td>
                                    <td>202198768</td>
                                    <td>55256701 | ABDUL LATIF B. OMAR</td>
                                    <td >H00001 | CUKAI TANAH SECARA BERULANG</td>
                                    <td >CUKAI TAHUNAN</td>
                                    <td align="right">200.00</td>
                                    <td align="right">
                                     <w-input  model-value="200.00" ></w-input>
                                    </td>
                                    <td align="center">
                                        <w-icon dark tile @click="destroy(item)">fal fa-trash</w-icon>
                                    </td>
                                </tr>
                                 <tr>
                                    <td>2</td>
                                    <td>PEJABAT DAERAH YANG BERSANGKUTAN</td>
                                    <td>202198768</td>
                                    <td>55256701 | ABDUL LATIF B. OMAR</td>
                                    <td >H00001 | CUKAI TANAH SECARA BERULANG</td>
                                    <td >CUKAI TAHUNAN</td>
                                    <td align="right">200.00</td>
                                    <td align="right">
                                     <w-input model-value="200.00" ></w-input>
                                    </td>
                                    <td align="center">
                                        <w-icon dark tile @click="destroy(item)">fal fa-trash</w-icon>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="7" align="right">JUMLAH</td>
                                    <td align="right">0.00</td>
                                    <td align="center"></td>
                                </tr>
                                <tr>
                                    <td colspan="7" align="right">PENGGENAPAN</td>
                                    <td align="right">0.00</td>
                                    <td align="center"></td>
                                </tr>
                                <tr>
                                    <td colspan="7" align="right">JUMLAH PERLU DIBAYAR</td>
                                    <td align="right">400.00</td>
                                    <td align="center"></td>
                                </tr>
                            </tbody>
                        </table>
                    </w-card>
                    </div>
            </z-page>

            <z-page title="Butiran Bayaran (Bil Pelbagai)" class="mt3">

                    <div class="table-hardcode">
                    <w-card bg-color="" class="table-hardcode">
                        <table class="table-dashboard" width="100%">
                            <thead>
                                <tr>
                                    <td>Bil</td>
                                    <td>Jabatan</td>
                                    <td>No. Rujukan</td>
                                    <td>Nama</td>
                                    <td>Kod Akaun</td>
                                    <td>Butiran Bayaran</td>
                                    <td>Amaun (RM)</td>
                                    <td>Amaun Bayar (RM)</td>
                                    <td> </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>PEJABAT DAERAH YANG BERSANGKUTAN</td>
                                    <td>202198768</td>
                                    <td>55256701 | ABDUL LATIF B. OMAR</td>
                                    <td >H00001 | CUKAI TANAH SECARA BERULANG</td>
                                    <td >CUKAI TAHUNAN</td>
                                    <td align="right">200.00</td>
                                    <td align="right">
                                     <w-input  model-value="200.00" ></w-input>
                                    </td>
                                    <td align="center">
                                        <w-icon dark tile @click="destroy(item)">fal fa-trash</w-icon>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="7" align="right">JUMLAH</td>
                                    <td align="right">0.00</td>
                                    <td align="center"></td>
                                </tr>
                                <tr>
                                    <td colspan="7" align="right">PENGGENAPAN</td>
                                    <td align="right">0.00</td>
                                    <td align="center"></td>
                                </tr>
                                <tr>
                                    <td colspan="7" align="right">JUMLAH PERLU DIBAYAR</td>
                                    <td align="right">400.00</td>
                                    <td align="center"></td>
                                </tr>
                            </tbody>
                        </table>
                    </w-card>
                    </div>
            </z-page>

            <z-page title="Cara Bayaran" class="mt3">
                <w-card bg-color="" class="table-hardcode">
                    <table class="table-dashboard" width="100%">
                          <thead>
                              <tr>
                                  <td>Bil</td>
                                  <td>Kaedah Bayaran</td>
                                  <td>Bank</td>
                                  <td>No. Transaksi</td>
                                  <td>Amaun (RM)</td>
                                  <td>
                                      <w-icon  @click="add(item)">fal fa-plus</w-icon>
                                  </td>
                              </tr>
                          </thead>
                          <tbody>
                              <tr>
                                  <td>1</td>
                                  <td>
                                       <w-select label="" :model-value="[{label: 'TUNAI'}]" :items="[{label: 'TUNAI'}, {label: 'BANK DERAF'}, {label: 'KOD KREDIT'}, {label: 'KOD DEBIT'}]"/>
                                  </td>
                                  <td>
                                       <w-select label="" :items="[{label: 'MAYBANK'}]" />
                                  </td>
                                  <td>
                                      <w-input required label="" model-value=""></w-input>
                                  </td>
                                  <td>
                                      <w-input required label="" model-value=""></w-input>
                                  </td>
                                  <td align="center">
                                      <w-icon dark tile @click="destroy(item)">fal fa-trash</w-icon>
                                  </td>
                              </tr>
                              <tr>
                                  <td>2</td>
                                  <td>
                                       <w-select label="" :model-value="[{label: 'BANK DERAF'}]" :items="[{label: 'TUNAI'}, {label: 'BANK DERAF'}, {label: 'KOD KREDIT'}, {label: 'KOD DEBIT'}]"/>
                                  </td>
                                  <td>
                                       <w-select label="" :items="[{label: 'MAYBANK'}]" />
                                  </td>
                                  <td>
                                      <w-input required label="" model-value=""></w-input>
                                  </td>
                                  <td>
                                      <w-input required label="" model-value=""></w-input>
                                  </td>
                                  <td align="center">
                                      <w-icon dark tile @click="destroy(item)">fal fa-trash</w-icon>
                                  </td>
                              </tr>
                              <tr>
                                  <td>3</td>
                                  <td>
                                       <w-select label="" :model-value="[{label: 'KOD KREDIT'}]" :items="[{label: 'TUNAI'}, {label: 'BANK DERAF'}, {label: 'KOD KREDIT'}, {label: 'KOD DEBIT'}]"/>
                                  </td>
                                  <td>
                                       <w-select label="" :items="[{label: 'MAYBANK'}]" />
                                  </td>
                                  <td>
                                      <w-input required label="" model-value=""></w-input>
                                  </td>
                                  <td>
                                      <w-input required label="" model-value=""></w-input>
                                  </td>
                                  <td align="center">
                                      <w-icon dark tile @click="destroy(item)">fal fa-trash</w-icon>
                                  </td>
                              </tr>
                              <tr>
                                  <td>4</td>
                                  <td>
                                       <w-select label="" :model-value="[{label: 'KOD DEBIT'}]" :items="[{label: 'TUNAI'}, {label: 'BANK DERAF'},{label: 'KOD KREDIT'}, {label: 'KOD DEBIT'}]"/>
                                  </td>
                                  <td>
                                       <w-select label="" :items="[{label: 'MAYBANK'}]" />
                                  </td>
                                  <td>
                                      <w-input required label="" model-value=""></w-input>
                                  </td>
                                  <td>
                                      <w-input required label="" model-value=""></w-input>
                                  </td>
                                  <td align="center">
                                      <w-icon dark tile @click="destroy(item)">fal fa-trash</w-icon>
                                  </td>
                              </tr>
                              <tr>
                                  <td colspan="4" align="right">JUMLAH</td>
                                  <td align="right">0.00</td>
                                  <td align="center"></td>
                              </tr>
                              <tr>
                                  <td colspan="4" align="right">Jumlah Perlu Dibayar</td>
                                  <td align="right">400.00</td>
                                  <td align="center"></td>
                              </tr>
                              <tr>
                                  <td colspan="4" align="right">Jumlah Perlu Dipulangkan</td>
                                  <td align="right">-400.00</td>
                                  <td align="center"></td>
                              </tr>
                          </tbody>
                    </table>
                </w-card>
            </z-page>
       
            <w-flex class="mt4" wrap align-center justify-end>
                <div class="spacer" />


                <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent">
                    <w-icon dark tile >fal fa-save</w-icon>
                </w-button>
            </w-flex>

        </w-form>

        <w-notification v-model="form.sent" success transition="bounce"
          absolute
          plain
          round
          bottom>
          Borang telah berjaya dihantar
        </w-notification>

    </z-page>

  </zen-one>
</template>

<script>

import Vue3ChartJs from '@j-t-mcc/vue3-chartjs'

export default {
components: {
  Vue3ChartJs
},
  setup () {
    const doughnutChart = {
      id: 'doughnut',
      type: 'doughnut',
      data: {

        labels: ['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],
        datasets: [
          {
            backgroundColor: [
              '#37479e',
              '#2f3d88',
              '#273371',
              '#1f285a'
            ],
            data: [40, 20, 80, 10]
          }
        ]
      },
      options: { plugins: { legend: { display: false }, } }

    }
  
    const beforeRenderLogic = (event) => {
      //...
      //if(a === b) {
      //  event.preventDefault()
      //}   
    }    

    return {
      doughnutChart,
      beforeRenderLogic
    }
  },
data() {
    return {
    dialog: {
        show: false,
        show2: false,
        fullscreen: false,
        persistent: false,
        persistentNoAnimation: false,
        width: 500
  },
  form: {
    valid: null,
    submitted: false,
    sent: false,
    errorsCount: 0,
  },
  validators: {
    required: value => !!value || 'This field is required',
    consent: value => !!value || 'You must agree'
  },
  crumbs: [
        { label: 'iHasil', route: '/' },
        { label: 'Kutipan', route: '/bilpelbagai' },
        { label: 'Terimaan', route: '/bilpelbagai/daftar' },
  ],
  showCard: false,
}},
methods: {

  onSuccess () {
    setTimeout(() => (this.form.sent = true), 2000)
    this.$inertia.visit(window.route('bilpelbagai.index'));

  },
  cetak() {
            window.location.href = route('kutipan.terimaan.cetak');
        },

  onValidate () {
    this.form.sent = false
    this.form.submitted = this.form.errorsCount === 0
  }
}
}

</script>

<style>


</style>